import { useAuth0 } from "src/contexts/auth0Provider";
import {
  TENANT_ROLE_RESOURCES,
  isInternalSupportUser,
  userHasGroupRole,
} from "src/services/auth";

import useTenantRoleNames from "./useTenantRoleNames";

/**
 * Whether the current user can manage tenant-level design access (e.g.
 * grant/revoke design admin). Mirrors the backend authorisation: a user is
 * allowed when they have the DTA-{tenantId} role on the current tenant.
 * Internal-support users always pass for parity with canPerform().
 *
 * @returns {boolean}
 */
const useCanManageDesignAccess = () => {
  const { user } = useAuth0() || {};
  const designRoles = useTenantRoleNames(TENANT_ROLE_RESOURCES.DESIGN);

  if (!user) {
    return false;
  }

  if (isInternalSupportUser(user)) {
    return true;
  }

  return userHasGroupRole(user, designRoles.ADMIN);
};

export default useCanManageDesignAccess;
